import { useSourceLanguage } from "../i18n/LocalizedCopy";
import useNavigationTranslations from "../i18n/useNavigationTranslations";
import React from "react";

import "./RegistryState.css";

export function RegistrySourceNote({ source, onRetry }) {
  useSourceLanguage();
  const { translateLabel } = useNavigationTranslations();
  if (source === "server") {
    return <p className="registry-source-note">{translateLabel("Statuts synchronisés avec le registre Eternua. Chaque fiche conserve sa propre date de vérification.")}</p>;
  }
  if (source === "loading") {
    return <p className="registry-source-note" role="status">{translateLabel("Chargement des statuts Eternua…")}</p>;
  }
  return (
    <div className="registry-source-note registry-source-note--error" role="alert">
      <p>{translateLabel("Le registre Eternua est indisponible. Aucun statut de remplacement n’est affiché.")}</p>
      {onRetry ? <button type="button" onClick={() => onRetry()}>{translateLabel("Réessayer le chargement des statuts")}</button> : null}
    </div>
  );
}

export function TodayPaymentNotice() {
  useSourceLanguage();
  const { translateLabel } = useNavigationTranslations();
  return (
    <div className="today-payment-notice" role="note">
      <strong>{translateLabel("Paiements en sandbox uniquement.")}</strong>
      <span>{translateLabel("Le checkout public et tout paiement réel restent désactivés pendant la recette Stripe et la période d’observation.")}</span>
    </div>
  );
}
